<template>
  <div>
    <button
      class="globalButton"
      :class="{
        modernCancel: type == 'cancel',
        white: type == 'white',
        positiveBtn: type == 'positive',
        negativeBtn: type == 'negative',
        neutralBtn: type == 'neutral',
        largeBtn: size == 'large',
        mediumBtn: size == 'medium',
        smallBtn: size == 'small',
      }"
      @click="$emit('eventPassed')"
      :disabled="disabled"
    >
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ButtonGlobal",
  props: {
    text: String,
    type: String,
    size: String,
    disabled: Boolean,
  },
};
</script>

<style scoped>
.globalButton {
  margin: 0 10px;
  width: 130px;
  height: 45px;
  border: none;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: white;
}
.globalButton:disabled {
  background-color: grey;
}
.globalButton:disabled:hover {
  cursor: not-allowed;
  background-color: grey;
}
.smallBtn {
  width: 110px;
  height: 40px;
}
.mediumBtn {
  width: auto;
  min-height: 45px;
  padding: 0px 25px;
}
.largeBtn {
  width: 300px;
  height: 45px;
}
.positiveBtn {
  background-color: #48b9ba;
  transition: 0.1s ease-in;
}
.positiveBtn:hover {
  background-color: #49a39c;
}
.negativeBtn {
  background-color: #894e99;
  transition: 0.1s ease-in;
}
.negativeBtn:hover {
  background-color: #764384;
}
.neutralBtn {
  background-color: #e8e8e8;
  color: #656565;
  transition: 0.1s ease-in;
}
.neutralBtn:hover {
  background-color: rgb(201, 201, 201);
}

.modernCancel {
  margin-left: 0px;
  margin-right: 0px;
  color: #aaaaaa;
  transition: 0.1s ease-in;
  background-color: #ffffff;
}

.white {
  margin-left: 0px;
  margin-right: 0px;
  background: #ffffff;
  border: 2px solid #707070;
  box-sizing: border-box;
  border-radius: 8px;
  color: #707070;
  box-shadow: none;
}
</style>
